"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  TransformDirectSelect: ['transform-direct-select', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18.682,7.035l-18-7A.5.5,0,0,0,.033.677l7,18.5a.5.5,0,0,0,.926.024l3.348-7.655a.5.5,0,0,1,.247-.252l7.158-3.34A.5.5,0,0,0,18.682,7.035Z', 'M17,14H14a1,1,0,1,0,0,2h3a5.006,5.006,0,0,1,5,5v2a1,1,0,0,0,2,0V21A7.008,7.008,0,0,0,17,14Z']],
  TransformLeft: ['transform-left', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M13.823,9.431A1,1,0,0,0,13,9H1a1,1,0,0,0-.823,1.57l9,13A1,1,0,0,0,10,24H22a1,1,0,0,0,.822-1.569ZM10.656,22a.249.249,0,0,1-.205-.107l-7.27-10.5A.25.25,0,0,1,3.386,11h8.959a.25.25,0,0,1,.206.108l7.27,10.5a.25.25,0,0,1-.206.392Z', 'M23,9H21.5a1,1,0,0,0,0,2h.25a.25.25,0,0,1,.25.25v.25a1,1,0,1,0,2,0V10A1,1,0,0,0,23,9Z', 'M23,14a1,1,0,0,0-1,1v3a1,1,0,0,0,2,0V15A1,1,0,0,0,23,14Z', 'M17,9a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Z', 'M8.673,6.877A.5.5,0,0,0,9.5,6.5V4.75a.25.25,0,0,1,.25-.25H18.5a1,1,0,0,0,0-2H9.751a.25.25,0,0,1-.25-.25V.5A.5.5,0,0,0,8.673.123l-3.455,3a.5.5,0,0,0,0,.754Z']],
  TransformInside: ['transform-inside', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14.5,2H16a1,1,0,0,0,0-2H14.5a1,1,0,0,0,0,2Z', 'M4,1H1A1,1,0,0,0,1,3H4A17.019,17.019,0,0,1,21,20v3a1,1,0,0,0,2,0V20A19.021,19.021,0,0,0,4,1Z', 'M12.116,10.116,5.9,16.336a.25.25,0,0,1-.354,0l-1.689-1.69A.5.5,0,0,0,3,15v5.5a.5.5,0,0,0,.5.5H9a.5.5,0,0,0,.354-.854l-1.69-1.689a.25.25,0,0,1,0-.354l6.22-6.219a1.25,1.25,0,0,0-1.768-1.768Z', 'M23,7a1,1,0,0,0-1,1V9.5a1,1,0,0,0,2,0V8A1,1,0,0,0,23,7Z', 'M22,0H20.5a1,1,0,0,0,0,2h1.25a.25.25,0,0,1,.25.25V3.5a1,1,0,0,0,2,0V2A2,2,0,0,0,22,0Z']],
  TransformRight: ['transform-right', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.821,10.57A1,1,0,0,0,23,9H11a1,1,0,0,0-.822.431l-9,13A1,1,0,0,0,2,24H14a1,1,0,0,0,.822-.43ZM13.549,21.893a.249.249,0,0,1-.205.107H4.385a.25.25,0,0,1-.206-.392l7.27-10.5A.253.253,0,0,1,11.655,11h8.959a.25.25,0,0,1,.2.393Z', 'M1,12.5a1,1,0,0,0,1-1v-.25a.25.25,0,0,1,.25-.25H2.5a1,1,0,1,0,0-2H1a1,1,0,0,0-1,1v1.5A1,1,0,0,0,1,12.5Z', 'M2,18V15a1,1,0,0,0-2,0v3a1,1,0,0,0,2,0Z', 'M6,9a1,1,0,1,0,0,2H7A1,1,0,0,0,7,9Z', 'M4.5,3.5a1,1,0,0,0,1,1h8.75a.25.25,0,0,1,.25.25V6.5a.5.5,0,0,0,.828.377l3.454-3a.5.5,0,0,0,0-.754l-3.454-3A.5.5,0,0,0,14.5.5V2.25a.25.25,0,0,1-.25.25H5.5A1,1,0,0,0,4.5,3.5Z']],
  TransformShrink: ['transform-shrink', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.01,1.632a.25.25,0,0,1,0-.355l.071-.07A.5.5,0,0,0,21.8.358L19.321.005a.5.5,0,0,0-.566.566l.353,2.475a.5.5,0,0,0,.849.282l.285-.285a.25.25,0,0,1,.348-.005A5.872,5.872,0,0,1,22,7a1,1,0,0,0,2,0A7.84,7.84,0,0,0,22.01,1.632Z', 'M6.4,20.253a.5.5,0,0,0-.87.211l-.089.392a.25.25,0,0,1-.293.189,5.9,5.9,0,0,1-3.3-2.607A1,1,0,0,0,.153,19.5,7.835,7.835,0,0,0,4.69,22.99a.247.247,0,0,1,.157.11.25.25,0,0,1,.033.19l-.022.1a.5.5,0,0,0,.69.569l2.285-1.015a.5.5,0,0,0,.178-.78Z', 'M23,10a1,1,0,0,0-1-1H20.173a.25.25,0,0,1-.248-.22,10,10,0,1,0-3.769,9.1.25.25,0,0,1,.331.02l2.087,2.087a1,1,0,0,0,1.414-1.414l-7.147-7.147A.25.25,0,0,1,13.018,11H22A1,1,0,0,0,23,10ZM10,9a1,1,0,0,0-.707,1.707l5.41,5.409a.251.251,0,0,1-.031.38A8,8,0,1,1,17.9,8.709.251.251,0,0,1,17.649,9Z']]
};
exports["default"] = _default;